import React from 'react';
import { Alert } from '@mui/material';

// Document validity is recorded at registration and judged by its date; nothing is verified with an
// external authority. The point of surfacing it here is that the two moments a lapsed permit matters
// — admitting a truck, and verifying it at the gate — are exactly where it was previously invisible.
const DAY = 86400000;

export const documentState = (document) => {
  const due = Date.parse(`${document?.expiresOn}T23:59:59`);
  if (!Number.isFinite(due)) return 'unknown';
  if (due < Date.now()) return 'expired';
  if (due < Date.now() + 14 * DAY) return 'expiring';
  return 'valid';
};

export const documentsInState = (vehicle, state) => (vehicle?.documents || []).filter((d) => documentState(d) === state);

// The worst state wins, so one lapsed permit is never buried under three valid ones.
export const documentSummary = (vehicle) => {
  const expired = documentsInState(vehicle, 'expired');
  if (expired.length) return { severity: 'error', text: `${expired.map((d) => `${d.kind} expired ${d.expiresOn}`).join(' · ')}` };
  const expiring = documentsInState(vehicle, 'expiring');
  if (expiring.length) return { severity: 'warning', text: `${expiring.map((d) => `${d.kind} expires ${d.expiresOn}`).join(' · ')}` };
  return null;
};

export const DocumentWarning = ({ vehicle, prefix = '', sx = undefined }) => {
  const summary = documentSummary(vehicle);
  if (!summary) return null;
  return <Alert severity={summary.severity} sx={sx}>{`${prefix}${summary.text}`}</Alert>;
};

export default documentSummary;
